<template>
  <section id="main-nav">
    <div class="nav-wrapper">
      <div class="header-bar">
        <div v-on:click="scrollTo('main-nav')" class="logo">
          <img src="./../assets/images/small/logo_s.png" alt="">
        </div>
        <button class="toggle-side-nav" v-on:click="sideNavActive = !sideNavActive"  v-bind:class="{ active: sideNavActive }">
          <span class="line line-top"></span>
          <span class="line line-middle"></span>
          <span class="line line-bottom"></span>
        </button>
      </div>
      <ul class="off-canvas" v-bind:class="{ active: sideNavActive }">
        <li><a v-on:click="scrollTo('home')">Home</a></li>
        <li><a v-on:click="scrollTo('about-us')">About Us</a></li>
        <li><a v-on:click="scrollTo('promotions')">Promotions</a></li>
        <!-- <li><a v-on:click="scrollTo('about-us')">Supermarket</a></li>
        <li><a v-on:click="scrollTo('about-us')">Butchery</a></li>
        <li><a v-on:click="scrollTo('about-us')">Meat Plant</a></li>
        <li><a v-on:click="scrollTo('about-us')">Distribution Centre</a></li> -->
        <li><a v-on:click="scrollTo('store-locator')">Store Locator</a></li>
        <li><router-link to="/news">News</router-link></li>
        <li><a v-on:click="scrollTo('contact-us')">Contact Us</a></li>
      </ul>
    </div>

    <div class="banner">
      <div class="banner-image"></div>
      <img class="banner-logo" src="./../assets/images/large/jwayelani-logo-full.png" alt="">
      <div class="banner-nav" v-sticky>
        <div class="container">
          <a class="logo" v-on:click="scrollTo('main-nav', 'landing')">
            <img src="./../assets/images/small/logo_s.png" alt="">
          </a>
          <ul>
            <li><a v-on:click="scrollTo('home', 'home')">Home</a></li>
            <li><a v-on:click="scrollTo('about-us', 'about us')">About Us</a></li>
            <li><a v-on:click="scrollTo('promotions', 'promotions')">Promotions</a></li>
            <!-- <li><a href="#" v-on:click="scrollTo('about-us')">Supermarket</a></li>
            <li><a href="#" v-on:click="scrollTo('about-us')">Butchery</a></li>
            <li><a href="#" v-on:click="scrollTo('about-us')">Meat Plant</a></li>
            <li><a href="#" v-on:click="scrollTo('about-us')">Distribution Centre</a></li> -->
            <li><a v-on:click="scrollTo('store-locator', 'store locator')">Store Locator</a></li>
            <li><router-link to="/news">News</router-link></li>
            <li><a v-on:click="scrollTo('contact-us', 'contact us')">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import Vue from 'vue'

export default {
  name: 'main-nav',
  data () {
    return {
      sideNavActive: false
    }
  },
  methods: {
    scrollTo: function (id, gaLabel) {
      window.gtag('event', 'click', {
        'event_category': 'main navigation',
        'event_label': gaLabel
      })
      Vue.$scrollTo.go(id, null, 60)
      this.sideNavActive = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../scss/colours.scss';
  @import '../scss/mixins.scss';

  section{
    margin-top: 60px;

    @include breakpoint(lg){
      margin-top: 0px;
    }
  }

  .choppies-logo{
    position: absolute;
    z-index: 51;
    top: 0;
    left: 20px;
    width: 125px;

    @include breakpoint(lg){
      width: 150px;
    }

    @include breakpoint(xl){
      width: 200px;
    }

    img{
      width: 100%;
      height: auto;
    }
  }

  .nav-wrapper{
  }

  .header-bar{
    z-index: 100;
    position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
    background-color: $red;
    border-bottom: 4px $red-dark solid;

    @include breakpoint(lg){
      display: none;
    }
  }

  .logo{
    display: inline-block;
    text-align: center;
    margin: 1em 20px;

    &:before{
      content: "";
      display: inline-block;
      height: 100%;
      vertical-align: middle;
    }

    img{
      width: 150px;
      vertical-align: middle;
    }
  }

  ul.off-canvas {
    z-index: 99;
    position: fixed;
    top: 60px;
    right: -200px;
    width: 100%;
    height: 100vh;
    padding: 20px 0;
    margin: 0 0 -60px;
    max-width: 200px;
    font-size: 22px;
    background-color: $red-dark;

    transition: transform 0.25s ease-out;

    @include breakpoint(lg){
      display: none;
    }

    &.active{
      transform: translateX(-100%);
    }

    li{
      display: block;
      list-style: none;
      line-height: 24px;
      text-align: left;
      height: auto;

      a{
        display: block;
        padding: 10px 20px;
        color: $yellow;

        &:hover{
          background-color: $red;
          text-decoration: none;
          color: lighten($yellow, 10%);
        }

        &:active{
          background-color: $red;
          text-decoration: none;
          color: lighten($yellow, 10%);
        }
      }
    }
  }

  .banner{
    position: relative;
    z-index: 50;
    overflow: hidden;
    width: 100%;
    padding-bottom: 56%;
    margin: 0;

    @media (min-width: 992px) and (min-aspect-ratio: 16/9){
      padding: 0;
      height: 100vh;
    }

    @include breakpoint(lg){
      z-index: 100;
    }

    .banner-image{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("./../assets/images/small/photo-home_s.jpg") no-repeat 0 60px fixed;
      background-size: 100% auto;
      //animation: none;

      @include breakpoint(sm){
        background-image: url("./../assets/images/medium/photo-home_m.jpg");
      }

      @include breakpoint(lg){
        background-image: url("./../assets/images/large/photo-home.jpg");
        background-position: 0 0;
      }

      @include breakpoint(xl){
        //background-size: cover;
      }
    }
  }

  .banner-nav{
    height: 60px;
    z-index: 100;
    position: absolute;
    bottom: 0;
    display: none;
    width: 100%;
    background-color: rgba(black, 0.4);

    transition: all 0.25s ease-in-out;

    @include breakpoint(lg){
      display: block;
    }

    &.stuck{
      position: fixed;
      top: 0;
      bottom: auto;
      background-color: $red;
      border-bottom: 4px $red-dark solid;

      a.logo{
        opacity: 1;
      }

      ul{
        margin-right: 0px;
        right: 0%;
        transform: translate(0%, 0);

        @include breakpoint(lg){
          //width: 775px;
          width: 500px;
        }

        @include breakpoint(xl){
          //width: 840px;
          width: 540px;
        }
      }

      li{
        font-size: 1.05em;

        @include breakpoint(xl){
          font-size: 1.15em;
          margin: 0 10px;
        }
      }
    }

    .container{
      position: relative;
    }

    a.logo{
      opacity: 0;
      position: absolute;
      left: 0px;
      top: 0px;

      transition: all 0.25s ease-in-out;
    }

    ul{
      position: absolute;
      top: 0;
      right: 50%;
      width: 100%;
      transform: translate(50%, 0);
      padding: 0;

      text-align: center;
      list-style: none;

      transition: all 0.25s ease-in-out;
    }

    li{
      //text-transform: uppercase;
      display: inline-block;
      font-size: 1.25em;
      line-height: 60px;
      margin: 0 10px;

      transition: all 0.25s ease-in-out;

      a{
        color: $yellow;
        cursor: pointer;

        &:hover{
          text-decoration: none;
          color: white;
        }

        &:active{
          text-decoration: none;
          color: darken($yellow, 20%)
        }
      }
    }
  }

  .banner-logo{
    display: none;
    position: absolute;
    width: 42%;
    height: auto;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);

    @include breakpoint(lg){
      display: block;
    }
  }

  .toggle-side-nav{
    z-index: 1;
    display: block;
    position: relative;
    width: 45px;
    height: 55px;
    float: right;
    margin: 0 10px;
    padding: 8px 8px 3px;
    outline: none;
    border: none;
    background-color: $red;

    @include breakpoint(lg){
      display: none;
    }

    .line{
      transform: rotate(0) translate(0, 0);
      transition: all 0.2s ease-in-out;
    }

    &.active{
      .line{

        &.line-middle{
          opacity: 0;
        }

        &.line-top{
          transform: rotate(45deg) translate(7.5px, 7px);
        }
        &.line-bottom{
          transform: rotate(-45deg) translate(7.5px, -7px);
        }
      }
    }

    .line{
      display: block;
      width: 100%;
      height: 5px;
      background-color: $yellow;
      margin-bottom: 5px;
    }

    @include clearfix();
  }

</style>



// WEBPACK FOOTER //
// src/components/MainNav.vue